import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HabitTracker } from './pages/habit-tracker/index';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" exact element={<HabitTracker />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
